import { FormProvider } from '@/context/FormProvider';

import {
  type ForgotPasswordConfirmFormValues,
  forgotPasswordConfirmValidationSchema,
  type ForgotPasswordRequestFormValues,
  forgotPasswordRequestValidationSchema,
  loginValidationSchema,
  type ResetPasswordFormValues,
  resetPasswordValidationSchema,
} from '@/schemas/auth.schema';

import type { LoginCredentials } from '@/types/auth.type';
import type { Props } from '@/types/formik.type';

export const LoginFormProvider = ({ children, onSubmit }: Props<LoginCredentials>) => {
  const initialValues: LoginCredentials = {
    username: '',
    password: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={loginValidationSchema}
    >
      {children}
    </FormProvider>
  );
};

export const ResetPasswordFormProvider = ({
  children,
  onSubmit,
}: Props<ResetPasswordFormValues>) => {
  const initialValues: ResetPasswordFormValues = {
    first_name: '',
    last_name: '',
    new_password: '',
    confirm_new_password: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={resetPasswordValidationSchema}
    >
      {children}
    </FormProvider>
  );
};

export const ForgotPasswordConfirmFormProvider = ({
  children,
  onSubmit,
}: Props<ForgotPasswordConfirmFormValues>) => {
  const initialValues: ForgotPasswordConfirmFormValues = {
    confirmation_code: '',
    new_password: '',
    confirm_new_password: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={forgotPasswordConfirmValidationSchema}
    >
      {children}
    </FormProvider>
  );
};

export const ForgotPasswordRequestFormProvider = ({
  children,
  onSubmit,
}: Props<ForgotPasswordRequestFormValues>) => {
  const initialValues: ForgotPasswordRequestFormValues = {
    username: '',
  };

  return (
    <FormProvider
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={forgotPasswordRequestValidationSchema}
    >
      {children}
    </FormProvider>
  );
};
